import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, act, useFetch } from "@/lib/api";
import { Panel, Badge, Field } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const NAME = { linkedin: "LinkedIn", x: "X", meta: "Meta (Facebook Page + Instagram)" };

export const SocialPanel = () => {
  const { data, reload } = useFetch("/social/status");
  const [t, setT] = useState({});
  useEffect(() => { if (data) setT(data.targets || {}); }, [data]);
  useEffect(() => {
    const q = new URLSearchParams(window.location.search).get("social");
    if (q) { (q.startsWith("error") ? toast.error : toast.success)(q); window.history.replaceState({}, "", "/settings"); }
  }, []);
  const connect = async (app) => { const r = await act(() => api.post(`/oauth/social/${app}/start`)); if (r?.url) window.location.href = r.url; };
  const disconnect = async (app) => { await act(() => api.delete(`/oauth/social/${app}`), "Disconnected"); reload(); };
  if (!data) return null;
  return (
    <Panel title="Social publishing" data-testid="social-panel">
      <div className="divide-y divide-border/60">{data.apps.map((a) => (
        <div key={a.app} className="py-2.5 flex items-center gap-3" data-testid={`social-app-${a.app}`}>
          <div className="flex-1 min-w-0"><div className="text-sm">{NAME[a.app]}</div>
            <div className="text-[11px] text-zinc-500 truncate">{a.connected && a.account ? `Posting as ${a.account}` : a.app_ready ? `Redirect URI: ${a.redirect_uri}` : "Developer app keys not added yet — copy & post manually meanwhile"}</div></div>
          <Badge v={a.connected ? "connected" : a.app_ready ? "ready" : "not_connected"} />
          {a.connected ? <Button size="sm" variant="ghost" data-testid={`social-disconnect-${a.app}`} onClick={() => disconnect(a.app)}>Disconnect</Button>
            : <Button size="sm" variant="secondary" disabled={!a.app_ready} data-testid={`social-connect-${a.app}`} onClick={() => connect(a.app)}>Connect</Button>}
        </div>
      ))}</div>
      <div className="grid grid-cols-3 gap-2 mt-3">
        {[["linkedin_org_id", "LinkedIn org ID"], ["facebook_page_id", "Facebook Page ID"], ["instagram_user_id", "Instagram account ID"]].map(([k, l]) => (
          <Field key={k} label={l}><Input data-testid={`social-target-${k}`} value={t[k] || ""} onChange={(e) => setT({ ...t, [k]: e.target.value })} className="bg-black font-mono text-xs" /></Field>
        ))}
      </div>
      <p className="text-[11px] text-zinc-500 mt-2" data-testid="social-linkedin-hint">Leave the LinkedIn org ID empty to post from your own profile. Once LinkedIn approves company-page posting for your app, enter the ID, save, then Disconnect and Connect LinkedIn again.</p>
      <Button size="sm" variant="secondary" className="mt-3" data-testid="social-targets-save" onClick={async () => { await act(() => api.patch("/social/targets", t), "Saved"); reload(); }}>Save page IDs</Button>
    </Panel>
  );
};
